import { makeAutoObservable } from 'mobx';

class StudentsListFilterStore {
  constructor() {
    this.name_filter = '';
    this.education_formats_filter = [];
    this.education_classes_filter = [];

    makeAutoObservable(this);
  }

  setNameFilter = value => {
    this.name_filter = value;
  };

  setEducationFormatsFilter = value => {
    this.education_formats_filter = value;
  };

  setEducationClassesFilter = value => {
    this.education_classes_filter = value;
  };

  setAllFilters = value => {
    this.name_filter = value?.name ?? '';
    this.education_formats_filter = value?.education_formats || [];
    this.education_classes_filter = value?.education_classes || [];
  };
}

export default StudentsListFilterStore;
